<template>
  <el-dialog
    :center="center"
    :close-on-click-modal="closeOnClickModal"
    :width="dialogWidth"
    :visible="dialogVisible"
    top="8vh"
    @close="closeDialog"
  >
    <template #title>
      <span class="el-dialog__title">退课</span>
    </template>
    <div class="backgroud-white cs-channel-editor" v-loading="loading">
      <div class="backgroud-gray-popup popup-content-area-small">
        <el-form ref="form" :model="model" label-position="left" label-width="100px">
          <el-form-item label="真留项目" class="cs-form-label-row">
            <span>{{ dataIn.serviceItemName }}</span>
          </el-form-item>
          <el-form-item label="课程学期" class="cs-form-label-row">
            <span>{{ dataIn.termName }}</span>
          </el-form-item>
          <el-form-item label="课程课号" class="cs-form-label-row">
            <span>{{ dataIn.courseName }}{{dataIn.isVIP ? "(VIP)" : ""}}</span>
          </el-form-item>
          <el-form-item label="报名小时数" v-if="dataIn.isVIP" class="cs-form-label-row">
            <span>{{ dataIn.hours }}</span>
          </el-form-item>
          <el-row class="cs-refund-description">
            <el-col
              ><span
                >确定要给该学生的{{dataIn.courseName}}进行退课吗？确认退课将不退还真留余额，该学生将不属于{{dataIn.courseName}}的学生</span
              ></el-col
            >
          </el-row>
          <el-form-item label="已上课时" prop="hours">
             <el-input
              v-model="model.hours"
              placeholder="请输入已上课时"
              oninput="value=value.replace(/[^0-9]/gi,'')"
              @blur="onHourChange"
              ><template slot="append">小时</template></el-input
            >
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer popup-footer">
        <el-row>
          <el-col :span="24" class="text-center">
            <span v-if="!showError"></span>
            <el-alert
              :closable="false"
              v-if="showError"
              v-bind:title="errorMessage"
              type="error"
              show-icon
            ></el-alert>
          </el-col>
          <el-col class="text-center" :span="24">
            <el-button :disabled="loading" type="primary" @click="onCancel"
              >取消</el-button
            >
            <el-button :disabled="loading" type="primary" @click="onSave"
              >确认退课</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.cs-channel-editor {
  color: black;
  h6 {
    font-weight: bold;
  }
  /deep/ .el-form-item__label {
    color: black;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
}
.cs-refund-description{
  padding: 20px 0px;
  border-top: 1px solid #ced3d9;
  border-bottom: 1px solid #ced3d9;
  margin-bottom: 20px;
}
.el-input{
  width: 200px;
}
</style>

<script>
import { mixinDevice } from "@/core/mixin";
import bonusPointMechanismVue from '../../page/admin/bonusPointMechanism.vue';
import { dropStudyAbroadCourse } from "../../service/studyAbroad.service";

export default {
  mixins: [mixinDevice],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    dataIn: {
      isVIP: Boolean,
      serviceItemName: String,
      termId: Number,
      termName: String,
      courseId: Number,
      courseName: String,
      hours: Number,
      workflowServiceItemId: Number,
      workflowCourseId: Number,
      universityGroup: Number,
    },
  },
  data() {
    return {
      model: {
        hours: 0,
      },

      dialogVisible: false,
      showError: false,
      loading: false,
      errorMessage: "",
    };
  },
  components: {},
  created() {
    this.dialogVisible = this.visible;
    this.init();
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    }
  },
  methods: {
    init() {
      if (!!this.dataIn) {
        this.model.hours = 0;
        this.showError = false;
      }
    },
    onSave() {
      if (!this.checkAllInputs()) {
        return;
      }

      if (this.dataIn.isVIP){
        if (this.model.hours > this.dataIn.hours){
          this.$message.warning("VIP课程已上课时数不能超出报名小时数");
          return;
        }
      }

      this.loading = true;
      dropStudyAbroadCourse(
        this.dataIn.workflowCourseId,
        this.model.hours
      ).then((result) => {
        if (result && result.success) {
          this.showError = false;
          this.$message.success("退课成功");
          this.$emit("saveSuccess", {
              workflowServiceItemId: this.dataIn.workflowServiceItemId,
              courseServiceRecordList: result.data,
            });
        }else{
          this.errorMessage = result.message;
          this.showError = true;
        }
        this.loading = false;
      });
    },
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      return isValid;
    },
    onHourChange(e){
      this.model.hours = e.target.value;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    onCancel(){
      this.dialogVisible = false;
    }
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/courseRefund.vue